"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Channel = void 0;
/**
 *
 * The channel, useful to determine if the agent is part of a campaign
 *
 * @public
 *
 */
var Channel;
(function (Channel) {
    Channel["Brokerage"] = "Brokerage";
    Channel["CallCenter"] = "Call Center";
    Channel["DTC"] = "DTC";
    Channel["ECommerceIndy"] = "eCommerceIndy";
    Channel["SalesCenter"] = "Sales Center";
    Channel["Unknown"] = "Unknown";
    Channel["Affiliates"] = "Affiliates";
})(Channel = exports.Channel || (exports.Channel = {}));
//# sourceMappingURL=Agent.js.map